import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/infopages.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />
      <main id="maincontent" className="page-main">
        <div className="page-title-wrapper"><h1 className="page-title"><span className="base">Returns &amp; Exchanges</span></h1></div>
        <div className="columns"><div className="column main">
          <p>We want you to receive the item you expected. Please review the conditions below before returning a purchase.</p>

          <h4>Return window</h4>
          <p>Contact us within 60 days of delivery to request a return. The product must normally be unused, in resalable condition, and returned with its original packaging and proof of purchase.</p>

          <h4>Items that cannot usually be returned</h4>
          <ul>
            <li>Opened food, treats, supplements, or other consumable goods unless they are faulty.</li>
            <li>Used grooming, hygiene, bedding, or wearable items that cannot be safely resold.</li>
            <li>Personalised, clearance, final-sale, or gift-card purchases where the restriction was disclosed.</li>
          </ul>
          <p>Your statutory rights for faulty, damaged, or misdescribed goods are not affected.</p>

          <h4>Starting a return</h4>
          <p>Email <a href="mailto:group@hetcratehub.today">group@hetcratehub.today</a> with your order reference, the item, and the reason for return. Wait for return instructions before sending the parcel. Unless the item is faulty or incorrect, return delivery costs are normally your responsibility.</p>

          <h4>Damaged or incorrect orders</h4>
          <p>Contact us promptly and keep the item and packaging. Include photographs where possible so we can assess the issue and arrange an appropriate replacement, refund, or other remedy.</p>

          <h4>Refunds and exchanges</h4>
          <p>Approved refunds are sent to the original payment method after the return is received and inspected. Bank processing time may vary. For an exchange, we may ask you to return the original item and place a separate order so the replacement is not delayed.</p>

          <h4>Manufacturer warranties</h4>
          <p>A product covered by a separate manufacturer warranty may need to follow that manufacturer's process. We can provide reasonable assistance with proof of purchase and available product information.</p>
        </div></div>
      </main>
      <Footer />
    </div>
  );
}

export default Returns;
